var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{ref:"anchor",attrs:{"href":_vm.href,"data-toggle":"tooltip","title":_vm.label},on:{"click":function($event){$event.stopPropagation();return _vm.click($event)}}},[_c('i',{class:_vm.icon})])])}
var staticRenderFns = []

export { render, staticRenderFns }